import React from 'react';

interface ResistorProps {
    value?: number;
    label?: string;
    x: number;
    y: number;
    rotation?: number;
    width?: number;
}

export const Resistor: React.FC<ResistorProps> = ({
    x,
    y,
    rotation = 0,
    width = 60
}) => {
    const height = 20;
    const halfWidth = width / 2;
    const leadLength = 10;
    const zigzagWidth = width - (2 * leadLength);
    const zigStep = zigzagWidth / 6;

    const pathData = `
    M ${-halfWidth} 0 
    L ${-halfWidth + leadLength} 0
    L ${-halfWidth + leadLength + zigStep * 0.5} ${-height / 2}
    L ${-halfWidth + leadLength + zigStep * 1.5} ${height / 2}
    L ${-halfWidth + leadLength + zigStep * 2.5} ${-height / 2}
    L ${-halfWidth + leadLength + zigStep * 3.5} ${height / 2}
    L ${-halfWidth + leadLength + zigStep * 4.5} ${-height / 2}
    L ${-halfWidth + leadLength + zigStep * 5.5} ${height / 2}
    L ${-halfWidth + leadLength + zigzagWidth} 0
    L ${halfWidth} 0
  `;

    return (
        <g transform={`translate(${x}, ${y}) rotate(${rotation})`}>
            <path d={pathData} stroke="#374151" strokeWidth="2" fill="none" strokeLinejoin="round" />
            {/* NO Internal Label Rendering */}
        </g>
    );
};
